import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { SupplierModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[Supplier] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[Supplier] Load items success', props<{ data: PaginationAdapter<SupplierModel> }>());

// item
export const loadItem = createAction('[Supplier] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[Supplier] Load item success', props<{ item: SupplierModel }>());
